/* -disable no-restricted-syntax */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import debounce from 'lodash.debounce';
import downloadjs from 'downloadjs';
import { SettingsInputComponent } from '@mui/icons-material';

import SubHeader from '../../components/SubHeader';
import Pagination from '../../components/Pagination';
import FiltersContainer from '../../components/Filter/FiltersContainer';
import Button from '../../components/Button';
import Icon from '../../components/Icon';
import CurrentFilters from '../../components/CurrentFilters';
import LoadingIndicator from '../../components/LoadingIndicator';
import RangeDatePicker from '../../components/RangeDatePicker';
import './styles.css';
import { luftGet, luftPost, luftDownload } from '../../shared/http';

import {
  TimeDashboard,
  DriverDashboard,
  DischargeDashboard,
  DischargeTable,
  DetailsDrawer,
  StatusColumn,
} from './components';

import DischargeTIcon from '../../assets/images/discharges-t.svg';
import DischargePIcon from '../../assets/images/discharges-p.svg';
import DischargeRIcon from '../../assets/images/discharges-r.svg';

import FilterDrawer from './components/FilterDrawer';
import PAEModal from './components/PAEModal';
import { DownloadButton, MoreFiltercontainer, PDFButton } from './styles';

import { SortingPropNames } from '../../utils/OrderTypes';
import { loggedUserRequestErrorHandler } from '../../shared/http/error';

const INITIAL_FILTER_PERIOD = 30;

const TABS = {
  drivers: 'MOTORISTAS',
  discharges: 'BAIXAS',
  time: 'TEMPO',
};

const VIEW_TYPE = {
  dashboard: 'Dashboard',
  discharges: 'Baixas',
  table: 'Tabela',
};

const STATUS_FILTER_OPTIONS = [
  'Baixa total com foto',
  'Baixa total sem foto',
  'Baixa parcial com foto',
  'Baixa parcial sem foto',
  'Baixa recusada com foto',
  'Baixa recusada sem foto',
];

const DISCHARGE_DURATION_OPTIONS = [
  '0 - 9min',
  '10 - 59min',
  '1h - 3h59min',
  '4h ou mais',
];

const TRANSMISSION_DELAY_OPTIONS = [
  '0 - 9min',
  '10 - 59min',
  '1h - 3h59min',
  '4h - 9h59min',
  '10h ou mais',
];

const IMAGE_ICON_TYPES = {
  withImage: 'with-image',
  withoutImage: 'no-image',
};

const DISCHARGES_ICONS = [
  {
    statusIcon: DischargeTIcon,
    imageIcon: IMAGE_ICON_TYPES.withImage,
  },
  {
    statusIcon: DischargeTIcon,
    imageIcon: IMAGE_ICON_TYPES.withoutImage,
  },
  {
    statusIcon: DischargePIcon,
    imageIcon: IMAGE_ICON_TYPES.withImage,
  },
  {
    statusIcon: DischargePIcon,
    imageIcon: IMAGE_ICON_TYPES.withoutImage,
  },
  {
    statusIcon: DischargeRIcon,
    imageIcon: IMAGE_ICON_TYPES.withImage,
  },
  {
    statusIcon: DischargeRIcon,
    imageIcon: IMAGE_ICON_TYPES.withoutImage,
  },
];

const PAGINATION_OPTIONS = [
  {
    value: 10,
    label: '10',
  },
  {
    value: 30,
    label: '30',
  },
  {
    value: 50,
    label: '50',
  },
  {
    value: 100,
    label: '100',
  },
];

const FILTER_PARAMS_ENUM = {
  period: 'period',
  issuingsubsidiaries: 'listSubsidiary',
  drivers: 'listDriver',
  plates: 'listPlate',
  cities: 'listCity',
  manifests: 'listManifest',
  recipients: 'listRecipient',
  senders: 'listSender',
  states: 'listState',
  billsofladings: 'listDelivery',
  invoices: 'listInvoice',
  discharges: 'listStatus',
  DischargeDuration: 'listDischargeDuration',
  TransmissionDelay: 'listTransmissionDelay',
};

const DEFAULT_AMOUNT = 50;
const SEARCH_BY_TERM_TIMEOUT = 1000;

class Discharges extends Component {
  constructor(props) {
    super(props);

    this.state = {
      paeDocument: {
        isModalOpen: false,
        isLoading: false,
        isNew: true,
        file: '(base64)',
        uploadedDate: '',
        userName: '',
      },
      selectedTab: TABS.drivers,
      selectedViewType: VIEW_TYPE.table,
      isFetching: true,
      isFetchingFilters: false,
      tableView: {
        currentPage: 1,
        totalItems: 0,
        pageLimit: DEFAULT_AMOUNT,
        isFetching: false,
      },
      driverTab: {
        currentPage: 1,
        totalItems: 0,
        pageLimit: 10,
        isFetching: false,
      },
      timeTab: {
        currentPage: 1,
        totalItems: 0,
        pageLimit: DEFAULT_AMOUNT,
        isFetching: false,
      },
      detailsDrawer: {
        data: null,
        isDrawerOpen: false,
      },
      finishedBillOfLadings: [],
      issuesubsidiaries: {
        data: [],
        total: 0,
        page: 1,
      },
      drivers: {
        data: [],
        total: 0,
        page: 1,
      },
      plates: {
        data: [],
        total: 0,
        page: 1,
      },
      cities: {
        data: [],
        total: 0,
        page: 1,
      },
      manifests: {
        data: [],
        total: 0,
        page: 1,
      },
      recipients: {
        data: [],
        total: 0,
        page: 1,
      },
      senders: {
        data: [],
        total: 0,
        page: 1,
      },
      states: {
        data: [],
        total: 0,
        page: 1,
      },
      billsofladings: {
        data: [],
        total: 0,
        page: 1,
      },
      invoices: {
        data: [],
        total: 0,
        page: 1,
      },
      discharges: {
        data: this._getMultiSelectOptions(STATUS_FILTER_OPTIONS),
      },
      DischargeDuration: {
        data: this._getMultiSelectOptions(DISCHARGE_DURATION_OPTIONS),
      },
      TransmissionDelay: {
        data: this._getMultiSelectOptions(TRANSMISSION_DELAY_OPTIONS),
      },
      driverRanking: [],
      timeDashboard: [],
      timeDashboardAverages: {},
      dischargeDashboard: {
        totalDischarges: null,
        totalDelivery: null,
        parcialDelivery: null,
        refusedDelivery: null,
        totalPercentage: null,
        parcialPercentage: null,
        refusedPercentage: null,
        withPhoto: null,
        withoutPhoto: null,
        withPhotoPercentage: null,
        withoutPhotoPercentage: null,
      },
      sorting: this._getInitialSortingState(),
      currentFilterIndex: 1,
      isFilterDrawerOpen: false,
      filters: {
        period: {
          name: 'Período',
          value: {
            finalPeriod: moment().format('YYYY-MM-DD'),
            initialPeriod: moment()
              .subtract(INITIAL_FILTER_PERIOD, 'day')
              .format('YYYY-MM-DD'),
          },
          clear: callBack => {
            this.setState(
              prevState => ({
                ...prevState,
                filters: {
                  ...prevState.filters,
                  period: { ...prevState.filters.period, value: {} },
                },
              }),
              () => {
                if (callBack) {
                  this._getDataByType();
                }
              },
            );
          },
          shouldRenderObject: true,
        },
        issuingsubsidiaries: this._setStateFilters(
          'Filial Emissora',
          'issuingsubsidiaries',
        ),
        drivers: this._setStateFilters('Motorista', 'drivers'),
        plates: this._setStateFilters('Placa', 'plates'),
        cities: this._setStateFilters('Cidade', 'cities'),
        manifests: this._setStateFilters('Manifesto', 'manifests'),
        recipients: this._setStateFilters('Destinatário', 'recipients'),
        senders: this._setStateFilters('Remetente', 'senders'),
        states: this._setStateFilters('Estado', 'states'),
        billsofladings: this._setStateFilters(
          'Conhecimento (CTE)',
          'billsofladings',
        ),
        invoices: this._setStateFilters('Nota Fiscal (NF)', 'invoices'),
        discharges: this._setStateFilters('Baixa/Foto', 'discharges'),
        DischargeDuration: this._setStateFilters(
          'Duração da baixa',
          'DischargeDuration',
        ),
        TransmissionDelay: this._setStateFilters(
          'Delay de Transmissão',
          'TransmissionDelay',
        ),
      },
    };

    this._searchByTerm = debounce((type, term) => {
      this.setState(
        prevState => ({
          [type]: {
            ...prevState[type],
            page: 0,
            data: prevState[type].data.filter(item => item.name.includes(term)),
          },
          filters: {
            ...prevState.filters,
            [type]: {
              ...prevState.filters[type],
              searchTerm: term,
            },
          },
        }),
        () => {
          this._getFilterByType(type, DEFAULT_AMOUNT);
        },
      );
    }, SEARCH_BY_TERM_TIMEOUT);
  }

  componentDidMount() {
    this._getInitialFilterOptions();
    this._getDataByType();
  }

  _requestPaeDocument = async () => {
    try {
      this.setState(prevState => ({
        paeDocument: {
          ...prevState.paeDocument,
          isLoading: true,
        },
      }));
      const response = await luftGet('/QualityAssurance/GetLastDocumentPAE', {
        versionDate: moment(),
      });

      const {
        data: { isNew, fileBase64, uploadedDate, userName },
      } = response;

      this.setState(prevState => ({
        paeDocument: {
          ...prevState.paeDocument,
          isLoading: false,
          isNew,
          file: fileBase64,
          uploadedDate,
          userName,
        },
      }));
    } catch (error) {
      this.setState(prevState => ({
        paeDocument: {
          ...prevState.paeDocument,
          isLoading: false,
        },
      }));
    }
  };

  _setStateFilters = (name, filterType) => ({
    name,
    value: [],
    hasNextPage: true,
    searchTerm: null,
    clear: callBack => {
      this.setState(
        prevState => ({
          ...prevState,
          filters: {
            ...prevState.filters,
            [filterType]: {
              ...prevState.filters[filterType],
              value: [],
            },
          },
        }),
        () => {
          if (callBack) {
            this._getDataByType();
          }
        },
      );
    },
  });

  _getInitialSortingState = () => ({
    [SortingPropNames.FIELD]: null,
    [SortingPropNames.TYPE]: null,
  });

  _onOrderColumn = (field, orderType) => {
    this.setState(
      {
        sorting: {
          [SortingPropNames.FIELD]: field,
          [SortingPropNames.TYPE]: orderType,
        },
      },
      this._getFinishedBillOfLadings,
    );
  };

  _exportExcel = async () => {
    const { dispatch } = this.props;

    try {
      const filterParams = this._checkFiltersOnRequest();

      this.setState({ isFetching: true });

      const params = {
        ...filterParams,
      };

      const mimeType = 'application/ms-excel';
      const response = await luftDownload(
        '/DriverDashboard/GetFinishedBillOfLadingsExcelBase64String',
        {
          ...params,
        },
        'application/json' || null,
      );

      const data = `data:${mimeType};base64,${JSON.parse(response).data}`;
      const filename = 'tracking.xlsx';

      downloadjs(data, filename, mimeType);

      this.setState({ isFetching: false });
    } catch (error) {
      loggedUserRequestErrorHandler(dispatch, error, error.message);
    }
  };

  _renderSubHeaderActions = () => {
    const { selectedViewType } = this.state;
    return (
      <div className="Discharges__header-subtitle-actions">
        <Button
          skin={
            selectedViewType === VIEW_TYPE.dashboard ? 'transparent' : 'primary'
          }
          text={VIEW_TYPE.dashboard}
          textCapitalize
          className="Discharges__header-subtitle-actions__button"
          icon="dashboard"
          onClick={() => {
            this.setState(
              () => ({ selectedViewType: VIEW_TYPE.dashboard }),
              () => this._getDataByType(),
            );
          }}
        />
        <Button
          skin={
            selectedViewType === VIEW_TYPE.table ? 'transparent' : 'primary'
          }
          text={VIEW_TYPE.table}
          textCapitalize
          className="Discharges__header-subtitle-actions__button"
          icon="list"
          onClick={() => {
            this.setState(
              () => ({ selectedViewType: VIEW_TYPE.table }),
              () => this._getFinishedBillOfLadings(),
            );
          }}
        />
        <DownloadButton
          textCapitalize
          icon="in"
          onClick={() => {
            this._exportExcel();
          }}
        />
        <PDFButton onClick={() => this._openPAEModal()}>
          <SettingsInputComponent />
        </PDFButton>
      </div>
    );
  };

  _clearFilters = () => {
    const { filters } = this.state;
    const clearedFilter = {};
    for (const key of Object.keys(filters)) {
      if (key === 'period') {
        clearedFilter[key] = {
          ...filters[key],
          value: {
            // finalPeriod: moment().format('YYYY-MM-DD'),
            // initialPeriod: moment().subtract(INITIAL_FILTER_PERIOD, 'day').format('YYYY-MM-DD'),
          },
        };
      } else {
        clearedFilter[key] = { ...filters[key], value: [] };
      }
    }
    this.setState({ filters: { ...clearedFilter } });
  };

  _getTabItemStyle = tab => {
    const { selectedTab } = this.state;
    return selectedTab === tab
      ? 'Discharges__header-tabItem Discharges__header-tabItem__selected'
      : 'Discharges__header-tabItem';
  };

  _getTableData = () => {
    const { finishedBillOfLadings } = this.state;

    return finishedBillOfLadings.map(billOfLading => ({
      timeOfDischarge: billOfLading.finishedAt
        ? moment(billOfLading.finishedAt).format('DD/MM/YYYY HH:mm:ss')
        : '',
      cityAndState: `${
        billOfLading.recipient.state
      } - ${billOfLading.recipient.city.trim()}`,
      recipient: (billOfLading.recipient.name || '').trim(),
      driver: (billOfLading.driver.name || '').trim(),
      plate: billOfLading.driver.truckPlate,
      manifest: billOfLading.manifestNumber,
      billOfLading: billOfLading.id,
      status: <StatusColumn status={parseInt(billOfLading.status, 10)} />,
    }));
  };

  _checkFiltersOnRequest = () => {
    const { filters } = this.state;
    let params = {};

    for (const key of Object.keys(filters)) {
      if (
        key === 'period' &&
        filters[key].value &&
        filters[key].value.initialPeriod &&
        filters[key].value.finalPeriod
      ) {
        params = {
          ...params,
          ...filters[key].value,
        };
      } else if (filters[key].value.length) {
        params[FILTER_PARAMS_ENUM[key]] = filters[key].value.map(val => val.id);
      }
    }

    return params;
  };

  _getFinishedBillOfLadings = async ({ page, amount } = {}) => {
    const { dispatch } = this.props;

    window.scrollTo(0, 0);
    const { tableView, sorting } = this.state;
    const filterParams = this._checkFiltersOnRequest();

    this.setState({ isFetching: true });

    const params = {
      page: page || tableView.currentPage,
      amount: amount || tableView.pageLimit,
      ...filterParams,
      ...sorting,
    };

    try {
      const response = await luftGet(
        '/DriverDashboard/GetFinishedBillOfLadings',
        params,
      );

      this.setState(prevState => ({
        finishedBillOfLadings: (response.data || {}).finishedBillOfLading || [],
        tableView: {
          ...prevState.tableView,
          totalItems: (response.data || {}).totalLines,
        },
        isFetching: false,
      }));
    } catch (error) {
      loggedUserRequestErrorHandler(dispatch, error);
      this.setState({
        isFetching: false,
      });

      console.error(error.message);
    }
  };

  _changeTableViewPage = page => {
    window.scrollTo(0, 0);
    this.setState(prevState => ({
      tableView: {
        ...prevState.tableView,
        currentPage: page,
      },
    }));
    this._getFinishedBillOfLadings({ page });
  };

  _changeTableViewPageLimit = amount => {
    window.scrollTo(0, 0);
    this.setState(prevState => ({
      tableView: {
        ...prevState.tableView,
        pageLimit: amount,
      },
    }));
    this._getFinishedBillOfLadings({ amount });
  };

  _getDriverDashboard = async ({ page, amount } = {}) => {
    const { dispatch } = this.props;

    window.scrollTo(0, 0);
    const { driverTab } = this.state;
    const filterParams = this._checkFiltersOnRequest();

    this.setState({ isFetching: true });

    const params = {
      page: page || driverTab.currentPage,
      amount: amount || driverTab.pageLimit,
      ...filterParams,
    };

    try {
      const response = await luftGet(
        '/DriverDashboard/GetDriverRanking',
        params,
      );

      this.setState(prevState => ({
        driverRanking: response.data.drivers,
        driverTab: {
          ...prevState.driverTab,
          totalItems: response.data.totalLines,
        },
        isFetching: false,
      }));
    } catch (error) {
      loggedUserRequestErrorHandler(dispatch, error);

      this.setState({
        isFetching: false,
      });
    }
  };

  _changeDriverTabPage = page => {
    window.scrollTo(0, 0);
    this.setState(prevState => ({
      driverTab: {
        ...prevState.driverTab,
        currentPage: page,
      },
    }));
    this._getDriverDashboard({ page });
  };

  _changeDriverTabPageLimit = amount => {
    window.scrollTo(0, 0);
    this.setState(prevState => ({
      driverTab: {
        ...prevState.driverTab,
        pageLimit: amount,
      },
    }));
    this._getDriverDashboard({ amount });
  };

  _getDriverDashboardData = () => {
    const { driverRanking } = this.state;

    return (driverRanking || []).map((driver, index) => ({
      ranking: index + 1,
      name: driver.name.trim(),
      plates: driver.plates.map(plate => plate.name).join(', '),
      manifests: driver.totalManifests,
      invoices: driver.totalInvoices,
      discharges: driver.totalDischarges,
      actions: (
        // -disable-next-line jsx-a11y/anchor-is-valid
        <a
          title="Ver mais"
          className="Discharges__action-button"
          onClick={() => this._setDriverFilter(driver)}
        >
          Ver mais <Icon name="arrow_forward" />
        </a>
      ),
    }));
  };

  _setDriverFilter = ({ name, id }) => {
    this.setState(
      ({ drivers, filters, tableView }) => ({
        selectedViewType: VIEW_TYPE.table,
        tableView: {
          ...tableView,
          currentPage: 1,
        },
        drivers: {
          ...drivers,
          page: 1,
        },
        filters: {
          ...filters,
          drivers: {
            ...filters.drivers,
            value: [
              {
                name,
                id,
              },
            ],
          },
        },
      }),
      () => {
        this._getDataByType();
      },
    );
  };

  _getDiff = (start, end) => {
    const diff = moment(end).diff(moment(start));
    return moment.utc(diff).format('HH:mm:ss');
  };

  _getTimeDashboardDataAverage = () => {
    const { finishedBillOfLadings } = this.state;
    return finishedBillOfLadings.map(billOfLading => ({
      timeOfDischarge: moment(billOfLading.checkIn).format(
        'DD/MM/YYYY HH:mm:ss',
      ),
      stay: this._getDiff(billOfLading.checkIn, billOfLading.finishedAt),
      transmissionDelay: this._getDiff(
        billOfLading.finishedAt,
        billOfLading.receivedByLuft,
      ),
      driver: billOfLading.driver.name.trim(),
      plate: billOfLading.driver.truckPlate.trim(),
      manifest: billOfLading.manifestNumber,
      billOfLading: billOfLading.id,
      status: <StatusColumn status={parseInt(billOfLading.status, 10)} />,
    }));
  };

  _getDischardDashboarData = async () => {
    const { dispatch } = this.props;

    window.scrollTo(0, 0);
    this.setState({ isFetching: true });
    const filterParams = this._checkFiltersOnRequest();

    const params = {
      ...filterParams,
    };

    try {
      const response = await luftGet(
        '/DriverDashboard/GetDischargeDashboard',
        params,
      );

      this.setState({
        dischargeDashboard: response.data,
        isFetching: false,
      });
    } catch (error) {
      loggedUserRequestErrorHandler(dispatch, error);

      this.setState({
        isFetching: false,
      });
      console.error({ error: error.message });
    }
  };

  _getTimeDashboardAverages = async () => {
    const { dispatch } = this.props;

    window.scrollTo(0, 0);
    this.setState({ isFetching: true });
    const filterParams = this._checkFiltersOnRequest();

    const params = {
      ...filterParams,
    };
    try {
      const response = await luftGet(
        '/DriverDashboard/GetTimeDashboardAverages',
        params,
      );

      this.setState(
        () => ({
          timeDashboardAverages: response.data,
        }),
        () => this._getFinishedBillOfLadings(),
      );
    } catch (error) {
      loggedUserRequestErrorHandler(dispatch, error);

      this.setState({
        isFetching: false,
      });
      console.error({ error: error.message });
    }
  };

  _getInitialFilterOptions = async () => {
    const { dispatch } = this.props;

    try {
      this.setState({
        isFetchingFilters: true,
      });

      const [
        GetIssuingSubsidiariesFilter,
        GetSendersFilter,
        GetRecipientsFilter,
        GetCitiesFilter,
        GetStatesFilter,
        GetDriversFilter,
        GetPlatesFilter,
        GetManifestsFilter,
        GetBillsOfLadingFilter,
        GetInvoicesFilter,
      ] = await Promise.all([
        luftGet('/DriverDashboard/GetIssuingSubsidiariesFilter', {
          page: 1,
          amount: DEFAULT_AMOUNT,
        }),
        luftGet('/DriverDashboard/GetSendersFilter', {
          page: 1,
          amount: DEFAULT_AMOUNT,
        }),
        luftGet('/DriverDashboard/GetRecipientsFilter', {
          page: 1,
          amount: DEFAULT_AMOUNT,
        }),
        luftGet('/DriverDashboard/GetCitiesFilter', {
          page: 1,
          amount: DEFAULT_AMOUNT,
        }),
        luftGet('/DriverDashboard/GetStatesFilter', {
          page: 1,
          amount: DEFAULT_AMOUNT,
        }),
        luftGet('/DriverDashboard/GetDriversFilter', {
          page: 1,
          amount: DEFAULT_AMOUNT,
        }),
        luftGet('/DriverDashboard/GetPlatesFilter', {
          page: 1,
          amount: DEFAULT_AMOUNT,
        }),
        luftGet('/DriverDashboard/GetManifestsFilter', {
          page: 1,
          amount: DEFAULT_AMOUNT,
        }),
        luftGet('/DriverDashboard/GetBillsOfLadingFilter', {
          page: 1,
          amount: DEFAULT_AMOUNT,
        }),
        luftGet('/DriverDashboard/GetInvoicesFilter', {
          page: 1,
          amount: DEFAULT_AMOUNT,
        }),
      ]);

      this.setState(prevState => ({
        filters: {
          ...prevState.filters,
          issuingsubsidiaries: {
            ...prevState.filters.issuingsubsidiaries,
            hasNextPage:
              GetIssuingSubsidiariesFilter.data.totalLines >= DEFAULT_AMOUNT,
          },
          drivers: {
            ...prevState.filters.drivers,
            hasNextPage: GetDriversFilter.data.totalLines >= DEFAULT_AMOUNT,
          },
          plates: {
            ...prevState.filters.plates,
            hasNextPage: GetPlatesFilter.data.totalLines >= DEFAULT_AMOUNT,
          },
          cities: {
            ...prevState.filters.cities,
            hasNextPage: GetCitiesFilter.data.totalLines >= DEFAULT_AMOUNT,
          },
          manifests: {
            ...prevState.filters.manifests,
            hasNextPage: GetManifestsFilter.data.totalLines >= DEFAULT_AMOUNT,
          },
          recipients: {
            ...prevState.filters.recipients,
            hasNextPage: GetRecipientsFilter.data.totalLines >= DEFAULT_AMOUNT,
          },
          senders: {
            ...prevState.filters.senders,
            hasNextPage: GetSendersFilter.data.totalLines >= DEFAULT_AMOUNT,
          },
          states: {
            ...prevState.filters.states,
            hasNextPage: GetStatesFilter.data.totalLines >= DEFAULT_AMOUNT,
          },
          billsofladings: {
            ...prevState.filters.billsofladings,
            hasNextPage:
              GetBillsOfLadingFilter.data.totalLines >= DEFAULT_AMOUNT,
          },
          invoices: {
            ...prevState.filters.invoices,
            hasNextPage: GetInvoicesFilter.data.totalLines >= DEFAULT_AMOUNT,
          },
        },
        issuesubsidiaries: {
          data: GetIssuingSubsidiariesFilter.data.issuesubsidiaries || [],
          total: GetIssuingSubsidiariesFilter.data.totalLines,
          page: 1,
        },
        drivers: {
          data: GetDriversFilter.data.drivers || [],
          total: GetDriversFilter.data.totalLines,
          page: 1,
        },
        senders: {
          data: GetSendersFilter.data.senders || [],
          total: GetSendersFilter.data.totalLines,
          page: 1,
        },
        cities: {
          data: GetCitiesFilter.data.cities || [],
          total: GetCitiesFilter.data.totalLines,
          page: 1,
        },
        states: {
          data: GetStatesFilter.data.states || [],
          total: GetStatesFilter.data.totalLines,
          page: 1,
        },
        plates: {
          data: GetPlatesFilter.data.plates || [],
          total: GetPlatesFilter.data.totalLines,
          page: 1,
        },
        manifests: {
          data: GetManifestsFilter.data.manifests
            ? GetManifestsFilter.data.manifests.map(opt => ({
                id: opt.id.toString(),
                name: opt.number.toString(),
              }))
            : [],
          total: GetManifestsFilter.data.totalLines,
          page: 1,
        },
        recipients: {
          data: GetRecipientsFilter.data.recipients || [],
          total: GetRecipientsFilter.data.totalLines,
          page: 1,
        },
        invoices: {
          data: GetInvoicesFilter.data.invoices
            ? GetInvoicesFilter.data.invoices.map(opt => ({
                id: opt.id.toString(),
                name: opt.number.toString(),
              }))
            : [],
          total: GetInvoicesFilter.data.totalLines,
          page: 1,
        },
        billsofladings: {
          data: GetBillsOfLadingFilter.data.billsofladings
            ? GetBillsOfLadingFilter.data.billsofladings.map(opt => ({
                id: opt.id.toString(),
                name: opt.number.toString(),
              }))
            : [],
          total: GetBillsOfLadingFilter.data.totalLines,
          page: 1,
        },
        isFetchingFilters: false,
      }));
    } catch (error) {
      loggedUserRequestErrorHandler(dispatch, error);

      this.setState({
        isFetchingFilters: false,
      });
      console.error({ error: error.message });
    }
  };

  // -disable-next-line consistent-return
  _getFilterEndpoint = filterType => {
    switch (filterType) {
      case 'issuesubsidiaries':
        return 'GetIssuingSubsidiariesFilter';
      case 'drivers':
        return 'GetDriversFilter';
      case 'cities':
        return 'GetCitiesFilter';
      case 'plates':
        return 'GetPlatesFilter';
      case 'manifests':
        return 'GetManifestsFilter';
      case 'recipients':
        return 'GetRecipientsFilter';
      case 'states':
        return 'GetStatesFilter';
      case 'senders':
        return 'GetSendersFilter';
      case 'invoices':
        return 'GetInvoicesFilter';
      case 'billsofladings':
        return 'GetBillsOfLadingFilter';
      case 'discharges':
        return 'GetBillsOfLadingFilter';

      default:
        break;
    }
  };

  _getFilterByType = async (filterType, startIndex) => {
    const { dispatch } = this.props;

    const GetFilter = this._getFilterEndpoint(filterType);

    try {
      this.setState({
        isFetching: true,
      });

      const response = await luftGet(`/DriverDashboard/${GetFilter}`, {
        page: this.state[filterType].page + 1,
        amount: DEFAULT_AMOUNT,
        searchTerm: this.state.filters[filterType].searchTerm
          ? this.state.filters[filterType].searchTerm
          : '',
      });

      const data =
        filterType === 'manifests' ||
        filterType === 'invoices' ||
        filterType === 'billsofladings'
          ? response.data[filterType].map(opt => ({
              id: opt.id.toString(),
              name: opt.number.toString(),
            }))
          : response.data[filterType];

      this.setState(prevState => ({
        [filterType]: {
          data:
            (this.state[filterType].page
              ? data
                ? [...this.state[filterType].data, ...data]
                : this.state[filterType].data
              : data) || [],
          total: response.data.totalLines,
          page: this.state[filterType].page + 1,
        },
        filters: {
          ...prevState.filters,
          [filterType]: {
            ...prevState.filters[filterType],
            hasNextPage: response.data.totalLines >= startIndex,
          },
        },
        isFetching: false,
      }));
    } catch (error) {
      loggedUserRequestErrorHandler(dispatch, error);

      this.setState({
        isFetching: false,
      });
    }
  };

  _onOpenDrawer = row => {
    const { finishedBillOfLadings } = this.state;
    const selectedBillOfLading = finishedBillOfLadings.find(
      billOfLading => billOfLading.id === row.billOfLading,
    );

    this.setState({
      detailsDrawer: {
        data: selectedBillOfLading,
        isDrawerOpen: true,
      },
    });
  };

  _onDrawerDimiss = () => {
    this.setState(prevState => ({
      detailsDrawer: {
        ...prevState.detailsDrawer,
        isDrawerOpen: false,
      },
    }));
  };

  _onFilterDrawerOpen = () => {
    this.setState({
      isFilterDrawerOpen: true,
    });
  };

  _onFilterDrawerDismiss = () => {
    this.setState({
      isFilterDrawerOpen: false,
    });
  };

  _getDataByType = () => {
    if (this.state.selectedViewType === VIEW_TYPE.table) {
      this._getFinishedBillOfLadings();
      return;
    }
    if (this.state.selectedViewType === VIEW_TYPE.dashboard) {
      if (this.state.selectedTab === TABS.time) {
        this._getTimeDashboardAverages();
        return;
      }

      if (this.state.selectedTab === TABS.drivers) {
        this._getDriverDashboard();
        return;
      }
      if (this.state.selectedTab === TABS.discharges) {
        this._getDischardDashboarData();
      }
    }
  };

  _getMultiSelectOptions = options =>
    options.map((option, index) => ({
      id: index,
      name: option,
    }));

  _renderDischargesIcons = index => (
    <div>
      <img src={DISCHARGES_ICONS[index].statusIcon} alt="Status Icon" />
      <Icon
        className={
          DISCHARGES_ICONS[index].imageIcon === IMAGE_ICON_TYPES.withImage
            ? 'Discharges__image-icon Discharges__image-icon--active'
            : 'Discharges__image-icon'
        }
        name={DISCHARGES_ICONS[index].imageIcon}
      />
    </div>
  );

  _handleSearchByTerm = async (term, type) => {
    this._searchByTerm(type, term);
  };

  _openPAEModal = () => {
    this.setState(
      prevState => ({
        paeDocument: {
          ...prevState.paeDocument,
          isModalOpen: true,
        },
      }),
      () => this._requestPaeDocument(),
    );
  };

  _closePAEModal = () => {
    this.setState(prevState => ({
      paeDocument: {
        ...prevState.paeDocument,
        isModalOpen: false,
      },
    }));
  };

  _handleFileUpload = async fileObj => {
    try {
      this.setState(prevState => ({
        paeDocument: {
          ...prevState.paeDocument,
          isLoading: true,
        },
      }));
      await luftPost('/QualityAssurance/SaveDocumentPAE', {
        file: Object.values(fileObj)[0],
      });

      this.setState(
        prevState => ({
          paeDocument: {
            ...prevState.paeDocument,
            isLoading: false,
          },
        }),
        () => this._requestPaeDocument(),
      );
    } catch (error) {
      console.log({ error });
    }
  };

  render() {
    const {
      selectedTab,
      selectedViewType,
      timeDashboardAverages,
      tableView,
      isFetching,
      isFetchingFilters,
      detailsDrawer,
      dischargeDashboard,
      isFilterDrawerOpen,
      sorting,
      paeDocument,
    } = this.state;
    const header = document.getElementById('Header');
    const yPostion = header && header.getBoundingClientRect().y;

    const { isModalOpen } = paeDocument;

    return (
      <div>
        {isFetching || isFetchingFilters ? (
          <div
            style={{
              position: 'fixed',
              top: yPostion > -64 ? '64px' : '0',
              zIndex: '2',
            }}
            className="Discharges__loadmask"
          >
            <LoadingIndicator text="Carregando..." />
          </div>
        ) : null}
        {isModalOpen ? (
          <PAEModal
            onDismiss={this._closePAEModal}
            paeDocumentData={paeDocument}
            onUploadFile={this._handleFileUpload}
          />
        ) : null}
        <div>
          <div className="Discharges__header-container">
            <SubHeader
              title="Baixas do App"
              renderSide={this._renderSubHeaderActions}
            />
            <CurrentFilters
              filters={this.state.filters}
              onApplyFilters={this._getDataByType}
            />
            <div className="Discharges__header-actions-container">
              <div className="Discharges__header-filter-container">
                <FiltersContainer
                  isNextPageLoading={isFetching}
                  loadNextPage={this._getFilterByType}
                  currentFilters={this.state.filters}
                  defaultAmount={DEFAULT_AMOUNT}
                  alwaysShowPlaceholder
                  filters={[
                    {
                      identifier: 'Período',
                      label: 'Período',
                      type: 'period',
                      currentValue: this.state.filters.period.value,
                      onFilter: val => {
                        this.setState(
                          prevState => ({
                            ...prevState,
                            filters: {
                              ...prevState.filters,
                              period: {
                                ...prevState.filters.period,
                                value: val,
                              },
                            },
                          }),
                          () => {
                            this._getDataByType();
                          },
                        );
                      },
                      placeholder: 'Período',
                      customStyles: { minWidth: 340 },
                      customComponent: ({ value, onChange }) => {
                        const initialPeriod = value?.initialPeriod;
                        const finalPeriod = value?.finalPeriod;

                        const handleChangeStartDate = (date) => {
                          onChange({
                            initialPeriod: date,
                            finalPeriod: finalPeriod || date,
                          });
                        };

                        const handleChangeEndDate = (date) => {
                          onChange({
                            initialPeriod: initialPeriod || date,
                            finalPeriod: date,
                          });
                        };

                        return (
                          <RangeDatePicker
                            startDate={initialPeriod}
                            endDate={finalPeriod}
                            onChangeStartDate={handleChangeStartDate}
                            onChangeEndDate={handleChangeEndDate}
                            customPeriods={[
                              { key: 'LAST_30', label: '30 dias', days: 30 },
                              { key: 'LAST_60', label: '60 dias', days: 60 },
                              { key: 'LAST_90', label: '90 dias', days: 90 },
                            ]}
                          />
                        );
                      },
                    },
                    {
                      identifier: 'Emissora',
                      label: 'Emissora',
                      type: 'paginatedSelect',
                      filterType: 'issuesubsidiaries',
                      options: this.state.issuesubsidiaries.data,
                      currentValue:
                        this.state.filters.issuingsubsidiaries.value,
                      hasNextPage:
                        this.state.issuesubsidiaries.data.length !== 0,
                      onFilter: val => {
                        this.setState(
                          prevState => ({
                            ...prevState,
                            filters: {
                              ...prevState.filters,
                              issuingsubsidiaries: {
                                ...prevState.filters.issuingsubsidiaries,
                                value: val,
                              },
                            },
                          }),
                          () => {
                            this._getDataByType();
                          },
                        );
                      },
                      placeholder: 'Emissora',
                      onSearchByTerm: value =>
                        this._handleSearchByTerm(value, 'issuesubsidiaries'),
                    },
                    {
                      identifier: 'Baixa/Foto',
                      label: 'Baixa/Foto',
                      type: 'multiselect',
                      filterType: 'discharges',
                      options: this.state.discharges.data,
                      renderLeft: this._renderDischargesIcons,
                      onFilter: val => {
                        this.setState(
                          prevState => ({
                            ...prevState,
                            filters: {
                              ...prevState.filters,
                              discharges: {
                                ...prevState.filters.discharges,
                                value: val,
                              },
                            },
                          }),
                          () => {
                            this._getDataByType();
                          },
                        );
                      },
                      placeholder: 'Baixa/Foto',
                      currentValue: this.state.filters.discharges.value,
                      value: this.state.filters.discharges.value,
                    },
                    {
                      identifier: 'Motorista',
                      label: 'Motorista',
                      type: 'paginatedSelect',
                      filterType: 'drivers',
                      options: this.state.drivers.data,
                      hasNextPage: this.state.drivers.data.length !== 0,
                      onFilter: val => {
                        this.setState(
                          prevState => ({
                            ...prevState,
                            filters: {
                              ...prevState.filters,
                              drivers: {
                                ...prevState.filters.drivers,
                                value: val,
                              },
                            },
                          }),
                          () => {
                            this._getDataByType();
                          },
                        );
                      },
                      placeholder: 'Motorista',
                      currentValue: this.state.filters.drivers.value,
                      onSearchByTerm: value =>
                        this._handleSearchByTerm(value, 'drivers'),
                    },
                    {
                      identifier: 'Placa',
                      label: 'Placa',
                      type: 'paginatedSelect',
                      filterType: 'plates',
                      options: this.state.plates.data,
                      hasNextPage: this.state.plates.length !== 0,
                      onFilter: val => {
                        this.setState(
                          prevState => ({
                            ...prevState,
                            filters: {
                              ...prevState.filters,
                              plates: {
                                ...prevState.filters.plates,
                                value: val,
                              },
                            },
                          }),
                          () => {
                            this._getDataByType();
                          },
                        );
                      },
                      placeholder: 'Placa',
                      currentValue: this.state.filters.plates.value,
                      onSearchByTerm: value =>
                        this._handleSearchByTerm(value, 'plates'),
                    },
                    ...(selectedViewType === VIEW_TYPE.table
                      ? [
                          {
                            identifier: 'Destinatário',
                            label: 'Destinatário',
                            type: 'paginatedSelect',
                            filterType: 'recipients',
                            options: this.state.recipients.data,
                            hasNextPage: this.state.recipients.length !== 0,
                            onFilter: val => {
                              this.setState(
                                prevState => ({
                                  ...prevState,
                                  filters: {
                                    ...prevState.filters,
                                    recipients: {
                                      ...prevState.filters.recipients,
                                      value: val,
                                    },
                                  },
                                }),
                                () => {
                                  this._getDataByType();
                                },
                              );
                            },
                            placeholder: 'Destinatário',
                            currentValue: this.state.filters.recipients.value,
                            onSearchByTerm: value =>
                              this._handleSearchByTerm(value, 'recipients'),
                          },
                        ]
                      : []),
                    {
                      identifier: 'Cidade',
                      label: 'Cidade',
                      type: 'paginatedSelect',
                      options: this.state.cities.data,
                      filterType: 'cities',
                      hasNextPage: this.state.cities.length !== 0,
                      onFilter: val => {
                        this.setState(
                          prevState => ({
                            ...prevState,
                            filters: {
                              ...prevState.filters,
                              cities: {
                                ...prevState.filters.cities,
                                value: val,
                              },
                            },
                          }),
                          () => {
                            this._getDataByType();
                          },
                        );
                      },
                      placeholder: 'Cidade',
                      currentValue: this.state.filters.cities.value,
                      onSearchByTerm: value =>
                        this._handleSearchByTerm(value, 'cities'),
                    },
                  ]}
                />
              </div>
              <MoreFiltercontainer>
                <Button
                  onClick={this._onFilterDrawerOpen}
                  text="Mais filtros"
                  textCapitalize
                  skin="transparent"
                  icon="filter"
                />
              </MoreFiltercontainer>
              {selectedViewType === VIEW_TYPE.dashboard ? (
                <div className="Discharges__header-tabs">
                  <div
                    className={this._getTabItemStyle(TABS.drivers)}
                    onClick={() => {
                      this.setState({ selectedTab: TABS.drivers }, () =>
                        this._getDataByType(),
                      );
                    }}
                  >
                    Motoristas
                  </div>
                  <div
                    className={this._getTabItemStyle(TABS.discharges)}
                    onClick={() => {
                      this.setState({ selectedTab: TABS.discharges }, () =>
                        this._getDataByType(),
                      );
                    }}
                  >
                    Baixas
                  </div>
                  <div
                    className={this._getTabItemStyle(TABS.time)}
                    onClick={() => {
                      this.setState({ selectedTab: TABS.time }, () =>
                        this._getDataByType(),
                      );
                    }}
                  >
                    Tempo
                  </div>
                </div>
              ) : null}
              {selectedViewType === VIEW_TYPE.discharges ? (
                <div className="Discharges__header-tabs">
                  <div
                    className={this._getTabItemStyle(TABS.drivers)}
                    onClick={() => {
                      this._getDriverDashboard();
                      this.setState({ selectedTab: TABS.drivers });
                    }}
                  >
                    Motoristas
                  </div>
                  <div
                    className={this._getTabItemStyle(TABS.discharges)}
                    onClick={() => {
                      this._getDischardDashboarData();
                      this.setState({ selectedTab: TABS.discharges });
                    }}
                  >
                    Baixas
                  </div>
                  <div
                    className={this._getTabItemStyle(TABS.time)}
                    onClick={() => {
                      this._getFinishedBillOfLadings();
                      this.setState({ selectedTab: TABS.time });
                    }}
                  >
                    Tempo
                  </div>
                </div>
              ) : null}
            </div>
          </div>
          <div>
            {selectedViewType === VIEW_TYPE.table ? (
              <div>
                <DischargeTable
                  data={this._getTableData()}
                  openDetailsDrawer={this._onOpenDrawer}
                  onOrderColumn={this._onOrderColumn}
                  isFetching={false}
                  dataOrder={sorting}
                />
                {!isFetching ? (
                  <Pagination
                    options={PAGINATION_OPTIONS}
                    currentPage={tableView.currentPage}
                    pageLimit={tableView.pageLimit}
                    totalItems={tableView.totalItems}
                    onChangePage={this._changeTableViewPage}
                    onPageLimitChange={this._changeTableViewPageLimit}
                  />
                ) : null}
              </div>
            ) : null}
            {selectedViewType === VIEW_TYPE.dashboard &&
            selectedTab === TABS.drivers ? (
              <div>
                <DriverDashboard
                  data={this._getDriverDashboardData()}
                  isFetching={false}
                />
                {!isFetching ? (
                  <Pagination
                    options={PAGINATION_OPTIONS}
                    currentPage={this.state.driverTab.currentPage}
                    pageLimit={this.state.driverTab.pageLimit}
                    totalItems={this.state.driverTab.totalItems}
                    onChangePage={this._changeDriverTabPage}
                    onPageLimitChange={this._changeDriverTabPageLimit}
                  />
                ) : null}
              </div>
            ) : null}
            {selectedViewType === VIEW_TYPE.dashboard &&
            selectedTab === TABS.discharges ? (
              <div>
                <DischargeDashboard data={dischargeDashboard} />
              </div>
            ) : null}
            {selectedViewType === VIEW_TYPE.dashboard &&
            selectedTab === TABS.time ? (
              <div>
                <TimeDashboard
                  data={this._getTimeDashboardDataAverage()}
                  averages={timeDashboardAverages}
                />
                {!isFetching ? (
                  <Pagination
                    options={PAGINATION_OPTIONS}
                    currentPage={this.state.tableView.currentPage}
                    pageLimit={this.state.tableView.pageLimit}
                    totalItems={this.state.tableView.totalItems}
                    onChangePage={this._changeTableViewPage}
                    onPageLimitChange={this._changeTableViewPageLimit}
                  />
                ) : null}
              </div>
            ) : null}
          </div>
        </div>

        {detailsDrawer.isDrawerOpen && (
          <DetailsDrawer
            data={detailsDrawer.data}
            // stay={this._getDiff(detailsDrawer.data.checkIn, detailsDrawer.data.finishedAt)}
            // transmissionDelayCalc={this._getDiff(detailsDrawer.data.finishedAt, detailsDrawer.data.receivedByLuft)}
            onDismiss={this._onDrawerDimiss}
            status={0}
          />
        )}

        {isFilterDrawerOpen && (
          <FilterDrawer
            onDismiss={this._onFilterDrawerDismiss}
            alwaysShowPlaceholder
            isNextPageLoading={isFetching}
            onFilter={() => this._getDataByType()}
            currentFilters={this.state.filters}
            loadNextPage={this._getFilterByType}
            getFilterByType={this._getFilterByType}
            filters={[
              {
                identifier: 'Período',
                label: 'Período',
                type: 'period',
                filterType: 'period',
                currentValue: this.state.filters.period.value,
                onChange: val => {
                  this.setState(
                    prevState => ({
                      ...prevState,
                      filters: {
                        ...prevState.filters,
                        period: { ...prevState.filters.period, value: val },
                      },
                    }),
                    () => {},
                  );
                },
                placeholder: 'Período (data da baixa)',
                onClear: this.state.filters.period.clear,
              },
              {
                identifier: 'Filial Emissora',
                label: 'Emissora',
                type: 'paginatedSelect',
                filterType: 'issuesubsidiaries',
                options: this.state.issuesubsidiaries.data,
                currentValue: this.state.filters.issuingsubsidiaries.value,
                onClear: this.state.filters.issuingsubsidiaries.clear,
                onChange: val => {
                  this.setState(prevState => ({
                    ...prevState,
                    filters: {
                      ...prevState.filters,
                      issuingsubsidiaries: {
                        ...prevState.filters.issuingsubsidiaries,
                        value: val,
                      },
                    },
                  }));
                },
                placeholder: 'Emissora',
                onSearchByTerm: value =>
                  this._handleSearchByTerm(value, 'issuesubsidiaries'),
              },
              {
                identifier: 'Motorista',
                label: 'Motorista',
                type: 'paginatedSelect',
                filterType: 'drivers',
                options: this.state.drivers.data,
                onChange: val => {
                  this.setState(prevState => ({
                    ...prevState,
                    filters: {
                      ...prevState.filters,
                      drivers: { ...prevState.filters.drivers, value: val },
                    },
                  }));
                },
                placeholder: 'Motorista',
                currentValue: this.state.filters.drivers.value,
                onClear: this.state.filters.drivers.clear,
                onSearchByTerm: value =>
                  this._handleSearchByTerm(value, 'drivers'),
              },
              {
                identifier: 'Placa',
                label: 'Placa',
                type: 'paginatedSelect',
                filterType: 'plates',
                options: this.state.plates.data,
                onChange: val => {
                  this.setState(prevState => ({
                    ...prevState,
                    filters: {
                      ...prevState.filters,
                      plates: { ...prevState.filters.plates, value: val },
                    },
                  }));
                },
                placeholder: 'Placa',
                currentValue: this.state.filters.plates.value,
                onClear: this.state.filters.plates.clear,
                onSearchByTerm: value =>
                  this._handleSearchByTerm(value, 'plates'),
              },
              {
                identifier: 'Cidade',
                label: 'Cidade',
                type: 'paginatedSelect',
                filterType: 'cities',
                options: this.state.cities.data,
                onChange: val => {
                  this.setState(prevState => ({
                    ...prevState,
                    filters: {
                      ...prevState.filters,
                      cities: { ...prevState.filters.cities, value: val },
                    },
                  }));
                },
                placeholder: 'Cidade',
                currentValue: this.state.filters.cities.value,
                onClear: this.state.filters.cities.clear,
                onSearchByTerm: value =>
                  this._handleSearchByTerm(value, 'cities'),
              },
              {
                identifier: 'Estado',
                label: 'Estado',
                type: 'paginatedSelect',
                filterType: 'states',
                options: this.state.states.data,
                onChange: val => {
                  this.setState(prevState => ({
                    ...prevState,
                    filters: {
                      ...prevState.filters,
                      states: { ...prevState.filters.states, value: val },
                    },
                  }));
                },
                placeholder: 'Estado',
                currentValue: this.state.filters.states.value,
                onClear: this.state.filters.states.clear,
                onSearchByTerm: value =>
                  this._handleSearchByTerm(value, 'states'),
              },
              {
                identifier: 'Manifesto',
                label: 'Manifesto',
                type: 'paginatedSelect',
                filterType: 'manifests',
                options: this.state.manifests.data,
                onChange: val => {
                  this.setState(prevState => ({
                    ...prevState,
                    filters: {
                      ...prevState.filters,
                      manifests: { ...prevState.filters.manifests, value: val },
                    },
                  }));
                },
                placeholder: 'Manifesto',
                currentValue: this.state.filters.manifests.value,
                onClear: this.state.filters.manifests.clear,
                onSearchByTerm: value =>
                  this._handleSearchByTerm(value, 'manifests'),
              },
              {
                identifier: 'Destinatário',
                label: 'Destinatário',
                type: 'paginatedSelect',
                filterType: 'recipients',
                options: this.state.recipients.data,
                onChange: val => {
                  this.setState(prevState => ({
                    ...prevState,
                    filters: {
                      ...prevState.filters,
                      recipients: {
                        ...prevState.filters.recipients,
                        value: val,
                      },
                    },
                  }));
                },
                placeholder: 'Destinatário',
                currentValue: this.state.filters.recipients.value,
                onClear: this.state.filters.recipients.clear,
                onSearchByTerm: value =>
                  this._handleSearchByTerm(value, 'recipients'),
              },
              {
                identifier: 'Remetente',
                label: 'Remetente',
                type: 'paginatedSelect',
                filterType: 'senders',
                options: this.state.senders.data,
                onChange: val => {
                  this.setState(prevState => ({
                    ...prevState,
                    filters: {
                      ...prevState.filters,
                      senders: { ...prevState.filters.senders, value: val },
                    },
                  }));
                },
                placeholder: 'Remetente',
                currentValue: this.state.filters.senders.value,
                onClear: this.state.filters.senders.clear,
                onSearchByTerm: value =>
                  this._handleSearchByTerm(value, 'senders'),
              },
              {
                identifier: 'Conhecimento (CTE)',
                label: 'Conhecimento (CTE)',
                type: 'paginatedSelect',
                filterType: 'billsofladings',
                options: this.state.billsofladings.data,
                onChange: val => {
                  this.setState(prevState => ({
                    ...prevState,
                    filters: {
                      ...prevState.filters,
                      billsofladings: {
                        ...prevState.filters.billsofladings,
                        value: val,
                      },
                    },
                  }));
                },
                placeholder: 'Conhecimento (CTE)',
                currentValue: this.state.filters.billsofladings.value,
                onClear: this.state.filters.billsofladings.clear,
                onSearchByTerm: value =>
                  this._handleSearchByTerm(value, 'billsofladings'),
              },
              {
                identifier: 'Nota Fiscal (NF)',
                label: 'Nota Fiscal (NF)',
                type: 'paginatedSelect',
                filterType: 'invoices',
                options: this.state.invoices.data,
                onChange: val => {
                  this.setState(prevState => ({
                    ...prevState,
                    filters: {
                      ...prevState.filters,
                      invoices: { ...prevState.filters.invoices, value: val },
                    },
                  }));
                },
                placeholder: 'Nota Fiscal (NF)',
                currentValue: this.state.filters.invoices.value,
                onClear: this.state.filters.invoices.clear,
                onSearchByTerm: value =>
                  this._handleSearchByTerm(value, 'invoices'),
              },
              {
                identifier: 'Baixa/Foto',
                label: 'Baixa/Foto',
                type: 'multiselect',
                filterType: 'discharges',
                options: this.state.discharges.data,
                renderLeft: this._renderDischargesIcons,
                onChange: val => {
                  this.setState(prevState => ({
                    ...prevState,
                    filters: {
                      ...prevState.filters,
                      discharges: {
                        ...prevState.filters.discharges,
                        value: val,
                      },
                    },
                  }));
                },
                placeholder: 'Baixa/Foto',
                currentValue: this.state.filters.discharges.value,
                onClear: this.state.filters.discharges.clear,
              },
              {
                identifier: 'Duração da baixa',
                label: 'Duração da baixa',
                type: 'multiselect',
                filterType: 'DischargeDuration',
                options: this.state.DischargeDuration.data,
                onChange: val => {
                  this.setState(prevState => ({
                    ...prevState,
                    filters: {
                      ...prevState.filters,
                      DischargeDuration: {
                        ...prevState.filters.DischargeDuration,
                        value: val,
                      },
                    },
                  }));
                },
                placeholder: 'Duração da baixa',
                currentValue: this.state.filters.DischargeDuration.value,
                onClear: this.state.filters.DischargeDuration.clear,
              },
              {
                identifier: 'Delay de Transmissão',
                label: 'Delay de Transmissão',
                type: 'multiselect',
                filterType: 'TransmissionDelay',
                options: this.state.TransmissionDelay.data,
                onChange: val => {
                  this.setState(prevState => ({
                    ...prevState,
                    filters: {
                      ...prevState.filters,
                      TransmissionDelay: {
                        ...prevState.filters.TransmissionDelay,
                        value: val,
                      },
                    },
                  }));
                },
                placeholder: 'Delay de Transmissão',
                currentValue: this.state.filters.TransmissionDelay.value,
                onClear: this.state.filters.TransmissionDelay.clear,
              },
            ]}
          />
        )}
      </div>
    );
  }
}

export default connect()(Discharges);
